module.exports = __webpack_public_path__ + "img/logocenter.91cd84a9.png";